import React, { useState, useEffect } from 'react';
import amiraStillImage from '../../images/Amira_Still.png';
import { GetCharacterConfiguration } from '../../services/CharacterService';
import { getUserData } from '../../services/API';
import './StaticAmiraFallback.scss';

/**
 * Static fallback component for Amira avatar when WebGL fails to initialize.
 * Displays a static image of Amira in place of the animated Spine avatar.
 * Matches the positioning logic of the WebGL avatar.
 */
const StaticAmiraFallback = ({ isHidden }) => {
  const [positionClass, setPositionClass] = useState('');

  useEffect(() => {
    const updatePosition = () => {
      // Mirror the positioning logic from Coach.js renderAmira()
      const realToCSSPixels = window.devicePixelRatio;
      const isLowResScreen = realToCSSPixels < 2;
      const aspect = window.innerHeight / window.innerWidth;
      const highRatio = aspect >= 0.62;
      
      let className = '';
      if (highRatio) {
        className = 'high-ratio';
      } else if (isLowResScreen) {
        className = 'low-res';
      }
      
      setPositionClass(className);
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    
    return () => {
      window.removeEventListener('resize', updatePosition);
    };
  }, []);

  if (isHidden) {
    return null;
  }

  return (
    <div className={`static-amira-fallback ${positionClass}`}>
      <img 
        src={amiraStillImage}
        alt="Amira Avatar"
        className="static-amira-image"
      />
    </div>
  );
};

export default StaticAmiraFallback;
